module.exports = ["cent","copy","divide","gt","lt","not","para","times"]


//////////////////
// WEBPACK FOOTER
// ./~/stringify-entities/dangerous.json
// module id = 194
// module chunks = 147254134005266 182246549230831 215303740077764